// Components/HomePage/ContactUs.jsx
import React, { useEffect } from "react";
import { motion } from "framer-motion";

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

const staggerContainer = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.15 } },
};

const ContactUs = () => {
  useEffect(() => {
    // Load LeadConnector script
    const scriptId = "leadconnector-form-embed";
    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.src = "https://link.msgsndr.com/js/form_embed.js";
      script.id = scriptId;
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <section className="w-full bg-gray-50 pt-8 pb-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Header */}
        <motion.div
          className="max-w-lg mx-auto text-center mb-8"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0 }}
        >
          <motion.h2 variants={fadeUp} className="text-4xl font-extrabold text-gray-900 mb-4">
            Get In Touch
          </motion.h2>
          <motion.p variants={fadeUp} className="text-gray-600 leading-relaxed">
            We'd love to hear from you. Whether you have questions, need support, or want to learn more about our services, our team is here to help.
          </motion.p>
        </motion.div>

        {/* LeadConnector Embedded Form */}
        <motion.div
          className="w-full rounded-2xl overflow-hidden shadow-lg"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0 }}
          style={{ minHeight: "1010px" }} // optional for initial height
        >
          <iframe
            id="inline-P0C5LscyKugLJDW4UHwR"
            src="https://api.leadconnectorhq.com/widget/form/P0C5LscyKugLJDW4UHwR"
            style={{
              width: "100%",
              height: "100%",
              border: "none",
              borderRadius: "8px",
              minHeight: "1010px",
            }}
            title="Inquiry form"
            data-layout="{'id':'INLINE'}"
            data-trigger-type="alwaysShow"
            data-trigger-value=""
            data-activation-type="alwaysActivated"
            data-activation-value=""
            data-deactivation-type="neverDeactivate"
            data-deactivation-value=""
            data-form-name="Inquiry form"
            data-layout-iframe-id="inline-P0C5LscyKugLJDW4UHwR"
            data-form-id="P0C5LscyKugLJDW4UHwR"
          />
        </motion.div>

        {/* Google Map */}
        <motion.div
          className="w-full h-[350px] rounded-xl overflow-hidden shadow mt-10"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0 }}
        >
          <iframe
            title="Ashlar Building Group Location"
            src="https://www.google.com/maps?q=6200%20Stoneridge%20Mall%20Rd%20Pleasanton%20CA&output=embed"
            className="w-full h-full border-0"
            loading="lazy"
            allowFullScreen
          />
        </motion.div>

      </div>
    </section>
  );
};

export default ContactUs;